"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.register = register;
var _events = require("../../types/events");
var _view = require("../../types/view");
var _registration = require("../../types/registration");
var _action_types = require("../../constants/action_types");
var _register = require("../../api/register");
var _jsonpRequest = require("../../../browser/utils/jsonpRequest");
var _view2 = require("../view");
var _tracking = require("../../utils/tracking");
var _rememberedAccounts = require("../../utils/rememberedAccounts");
var _rememberedAccounts2 = require("../../types/rememberedAccounts");
function register(parameters) {
  const {
    email,
    password,
    phone,
    isProfessional,
    source
  } = parameters;
  return (dispatch, getState, context) => {
    const {
      agreement,
      isRememberAccountsFlow
    } = getState();
    dispatch({
      status: _registration.ERegisterStatus.Loading,
      type: _action_types.REGISTRATION_REGISTER_TYPE
    });
    return (0, _register.register)(context.httpApi, {
      email,
      password,
      phone,
      isProfessional,
      enableSubscription: agreement.marketingSubscriptionAccepted,
      isAcceptLicence: agreement.licenceAccepted,
      subdomain: context.subdomain
    }).then(response => {
      if (response.statusCode === 200) {
        const {
          logOnInfo,
          login
        } = response.response;
        Promise.all(logOnInfo.map(info => (0, _jsonpRequest.jsonpRequest)(`${info.logOnUrl}?` + `login=${encodeURIComponent(login)}&` + `token=${info.token}&` + `persistent=true`))).then(() => {
          dispatch({
            status: _registration.ERegisterStatus.Succeed,
            type: _action_types.REGISTRATION_REGISTER_TYPE
          });
          dispatch((0, _view2.changeView)(_view.EActiveView.EnterPhoneNumber, {
            email
          }));
          const wantsSubscription = agreement.marketingSubscriptionAccepted;
          context.emitter.emit(_events.EEventType.RegisterSucceed, {
            email,
            phone,
            isProfessional,
            wantsSubscription
          });
          (0, _tracking.trackRegistrationSuccess)({
            socialType: 'email',
            source,
            isProfessional
          });
          if (wantsSubscription) {
            (0, _tracking.trackWantsSubscription)(source);
          }
          if (isRememberAccountsFlow) {
            (0, _rememberedAccounts.saveAccount)({
              type: _rememberedAccounts2.ERememberedAccountType.Email,
              value: email
            });
          }
        }).catch(() => {
          dispatch({
            status: _registration.ERegisterStatus.Failed,
            type: _action_types.REGISTRATION_REGISTER_TYPE,
            errorType: _registration.ERegisterErrorType.Common,
            error: 'Произошла непредвиденная ошибка'
          });
        });
        return;
      }
      const errorKey = response.response.errors.length > 0 ? response.response.errors[0].key : null;
      const error = response.response.errors.length > 0 ? response.response.errors[0].message : response.response.message;
      let errorType = _registration.ERegisterErrorType.Common;
      switch (errorKey) {
        case 'EmailAlreadyExists':
          errorType = _registration.ERegisterErrorType.Email;
          break;
        case 'Email':
          errorType = _registration.ERegisterErrorType.Email;
          break;
        case 'PasswordError':
          errorType = _registration.ERegisterErrorType.Password;
          break;
        case 'ValidaionCodeIsInvalid':
          errorType = _registration.ERegisterErrorType.Phone;
          break;
      }
      dispatch({
        status: _registration.ERegisterStatus.Failed,
        type: _action_types.REGISTRATION_REGISTER_TYPE,
        errorType,
        error
      });
    }).catch(error => {
      context.logger.error(error, {
        domain: 'auth-widget.api.register'
      });
      dispatch({
        status: _registration.ERegisterStatus.Failed,
        type: _action_types.REGISTRATION_REGISTER_TYPE,
        errorType: _registration.ERegisterErrorType.Common,
        error: 'Произошла непредвиденная ошибка'
      });
    });
  };
}